export default "__VITE_ASSET__Nuq_smXk__"